import React from 'react';
import {NotificationContext} from '../context/notification-context';

export const useNotifications = () => {
  const context = React.useContext(NotificationContext);
  if (context === undefined) {
    const e = Error(`useNotifications must be used within NotificationProvider!`);
    console.group('Notification Context Error');
    console.dir(e);
    console.groupEnd();
  } else {
    return context;
  }
};